import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="bg-[#060d17] pt-20 pb-10 border-t border-white/10" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-65">
          {/* Brand Col */}
          <div className="md:col-span-5" data-id="element-66">
            <div className="inline-block mb-6" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/rZWYtw45vF5kRX1tewyoD9/WhatsApp_Image_2026-04-14_at_10.49.05-removebg-preview.png" alt="JML Ingeniería y Mantenimiento Industrial" className="h-20 w-auto object-contain brightness-0 invert" data-id="element-68" />
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md" data-id="element-69">
              Soluciones integrales para el área de Ingeniería Industrial,
              Construcción y Servicios Generales.
            </p>
          </div>

          {/* Links Col */}
          <div className="md:col-span-3" data-id="element-70">
            <h4 className="text-white font-bold font-heading text-lg mb-6" data-id="element-71">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-72">
              <li data-id="element-73">
                <a href="#inicio" className="text-gray-400 hover:text-jml-orange transition-colors" data-id="element-74">
                  Inicio
                </a>
              </li>
              <li data-id="element-75">
                <a href="#nosotros" className="text-gray-400 hover:text-jml-orange transition-colors" data-id="element-76">
                  Quiénes Somos
                </a>
              </li>
              <li data-id="element-77">
                <a href="#servicios" className="text-gray-400 hover:text-jml-orange transition-colors" data-id="element-78">
                  Servicios
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-4" data-id="element-79">
            <h4 className="text-white font-bold font-heading text-lg mb-6" data-id="element-80">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-81">
              <li className="flex items-center gap-3 text-gray-400" data-id="element-82">
                <Phone className="text-jml-blue shrink-0" size={20} data-id="element-83" />
                <span data-id="element-84">+56 9 2123 9377</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-85">
                <Mail className="text-jml-blue shrink-0" size={20} data-id="element-86" />
                <span data-id="element-87">contacto@jmlchile.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-88">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-89">
            &copy; {new Date().getFullYear()} JML Ingeniería y Mantención
            Industrial. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}